import { offerSessionUtils } from '@makemydeal/dr-shared-ui-utils';

export type TargetApp = 'MV' | 'SV';

export const getTargetApp = (): TargetApp => {
    const target = offerSessionUtils.getTarget();

    return target === 'MV' ? 'MV' : 'SV';
};
